import { render } from "./authenDesigner.vue?vue&type=template&id=71488bab&scoped=true"
import script from "./authenDesigner.vue?vue&type=script&lang=js"
export * from "./authenDesigner.vue?vue&type=script&lang=js"

import "./authenDesigner.vue?vue&type=style&index=0&id=71488bab&lang=scss&scoped=true"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71488bab"]])

export default __exports__